/**
 * Date
 * - d     Day of month (ex 1, 2, ..., 31)
 * - dd    Day of month (ex 01, 02, ..., 31)
 * - do    Day of month (ex 1st, 2nd, ..., 31st)
 * - EEE   Day of week (Mon, Tue, Wed, ..., Sun)
 * - LLLL  Month (ex January, February, ..., December)
 * - MM    Month (ex 01, 02, ..., 12)
 * - MMM   Month (ex Jan, Feb, ..., Dec)
 * - yyyy  Year (ex 2020)
 *
 * Time
 * - p     Long localized time (ex 12:00 AM)
 */
export enum DateFormats {
  YMD = 'yyyy-MM-dd',
  TIME = 'p',
  MILITARY_TIME = 'H:mm',
  MASK = 'MM/dd/yyyy',
  DISPLAY = 'LLLL d',
  DISPLAY_ABBR = 'LLL d',
  DISPLAY_ABBR_SUFFIX = 'LLL do',
  DISPLAY_SHORT = 'MM/dd',
  DISPLAY_DAY_OF_WEEK = 'EEE, LLLL d',
  DISPLAY_DAY_OF_WEEK_MONTH_ABBR = 'EEE, LLL d',
  DISPLAY_DAY_OF_WEEK_ABBR_WITH_TIME = 'EEE, LLL d, p',
  DISPLAY_DAY_OF_WEEK_FULL = 'EEEE, LLL d',
  DISPLAY_WITH_DAY_TIME = 'EEE, LLLL d, p',
  DISPLAY_WITH_YEAR = 'LLLL d, yyyy',
  DISPLAY_WITH_YEAR_SUFFIX = 'LLLL do, yyyy',
  DISPLAY_WITH_YEAR_MONTH_ABBR = 'LLL d, yyyy',
  DISPLAY_WITH_DAY_YEAR = 'EEE, LLLL d, yyyy',
  DISPLAY_WITH_DAY_YEAR_FULL = 'EEEE, LLLL d, yyyy',
  DISPLAY_WITH_DAY_YEAR_ABBR = 'EEE, LLL d, yyyy',
  DISPLAY_WITH_MONTH_DAY_AT_TIME_ABBR = `LLL d 'at' pa`,
  DISPLAY_WITH_WEEKDAY_SHORT_MONTH = `EEE, LLL d`,
  DISPLAY_SHORT_MONTH_NO_YEAR = `MMM d`,
  DISPLAY_WITH_YEAR_NO_DAY = `LLLL, yyyy`,
}
